import React from "react"
import { Link } from "gatsby"
import { Box, Flex } from "theme-ui"
import styled from "@emotion/styled"
import moment from "moment"
import { useBreakpointIndex } from "@theme-ui/match-media"

const BottomLinkWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;
    width: 30%;
    & .title {
        font-weight: 500;
        color: ${(props) => props.theme.colors.primary};
        text-align: left;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        width: 100%;
    }
`
const BottomLink = styled(Link)`
    display: flex;
    flex: 0 0 auto;
    width: 100%;
    justify-content: space-between;
    border-top: 1px solid ${(props) => props.theme.colors.primary};
    padding-top: 0.5rem;
    margin-bottom: 1rem;
    & span {
        margin-right: 1rem;
        font-weight: 500;
    }
    &:hover {
        text-decoration: none !important;
        border-top: 3px solid ${(props) => props.theme.colors.primary};
        transition: flex 0.3s linear;
        & .arrow {
            transition: all 0.3s linear;
            width: 4rem !important;
            @media screen and (max-width: ${(props) =>
                    props.theme.breakpoints[3]}) {
                width: 3rem !important;
            }
        }
    }
    & .arrow-wrapper {
        flex: 0 0 20%;
    }
`
const Index = ({ posts }) => {
    const breakpoint = useBreakpointIndex()
    return (
        <Box>
            <h2 style={{textAlign: "left"}}>Recent Post</h2>
            <Flex
                sx={{
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    width: "100%",
                    my: "1rem",
                }}
            >
                {posts.edges.map((post, index) => (
                    <BottomLinkWrapper key={index}>
                        <div className="title">{post.node.title}</div>
                        <BottomLink to={`/resources/${post.node.slug}`}>
                            <span>
                                {moment(post.node.published_date).format("LL")}
                            </span>
                            <Flex
                                sx={{
                                    flex: "0 0 auto",
                                    width: breakpoint > 4 ? "50%" : "70%",
                                    justifyContent: "end",
                                }}
                            >
                                <span>Read More</span>
                                <div className="arrow-wrapper">
                                    <div className="arrow"></div>
                                </div>
                            </Flex>
                        </BottomLink>
                    </BottomLinkWrapper>
                ))}
            </Flex>
        </Box>
    )
}

export default Index
